const translations = {
    header: 'Job Estimate'
};

export default translations;
